import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import SubmittalCoverPageService from '@/services/SettingsServices/SubmittalCoverPageService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    errors: null,
    successOnCreate: '',
    loading: false,
};

export const getSubmittalCoverPage = createAsyncThunk(
    'submittalCoverPage/getSubmittalCoverPage',
    async (_, { rejectWithValue }) => {
        try {
            const response = await SubmittalCoverPageService.getSubmittalCoverPage();
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const addSubmittalCoverPage = createAsyncThunk(
    'submittalCoverPage/addSubmittalCoverPage',
    async (data, { rejectWithValue }) => {
        try {
            const response = await SubmittalCoverPageService.addSubmittalCoverPage(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const submittalCoverPageSlice = createSlice({
    name: 'submittalCoverPage',
    initialState: model,
    reducers: {
        resetSubmittalCoverPageStateOnError: (state) => {
            state.errors = null;
        },
        resetSubmittalCoverPageStateOnSuccess: (state) => {
            state.successOnCreate = '';
        },
    },
    extraReducers: (builder) => {
        // get submittal cover page config
        builder.addCase(getSubmittalCoverPage.pending, (state) => {
            state.loading = true;
        }).addCase(getSubmittalCoverPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(getSubmittalCoverPage.rejected, (state) => {
            state.loading = false;
        });

        // add submittal cover page config
        builder.addCase(addSubmittalCoverPage.pending, (state) => {
            state.submitting = true;
        }).addCase(addSubmittalCoverPage.fulfilled, (state) => {
            state.submitting = false;
            state.successOnCreate = 'Submittal cover page configuration added successfully!';
        }).addCase(addSubmittalCoverPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetSubmittalCoverPageStateOnError,
    resetSubmittalCoverPageStateOnSuccess,
} = submittalCoverPageSlice.actions;

export default submittalCoverPageSlice.reducer;
